import { InfoIcon } from 'lucide-react'
import { type ElementRef, forwardRef } from 'react'

import { FormLabel } from '@/components/form/form'
import { Switch } from '@/components/switch/switch'

import { cn } from '@/lib/utils'

export interface SkipSwitchProps {
  value: boolean
  onChange: (checked: boolean) => void
}

export const SkipSwitch = forwardRef<ElementRef<typeof Switch>, SkipSwitchProps>(
  ({ value, onChange, ...restProps }, ref) => {
    return (
      <div className="flex items-center">
        <FormLabel className="mr-2 cursor-pointer">
          <span className={cn('flex items-center')}>
            <InfoIcon size={18} className="mr-1" /> Skip
          </span>
        </FormLabel>
        <Switch
          ref={ref}
          id="visibilitySwitch"
          checked={value}
          onCheckedChange={onChange}
          className="ml-auto"
          {...restProps}
        />
      </div>
    )
  }
)
SkipSwitch.displayName = 'SkipSwitch'
